// module
import React from 'react';
import { Link } from 'react-router-dom';
import { Box, ListItem, Typography } from '@mui/material';
// constants
import { PATHS } from 'common/constants';
// style1

import classes from './Technologies.module.scss';


const Card = (props) => {
  const { data } = props;
  return (
    <ListItem className={classes.item}>
      <Link to={PATHS.detailTechnology.replace(':slug', data?.slug)}>
        <Box component='img' className={classes.inactive_image} src={data?.active_icon} alt={data?.active_icon_alt}/>
        <Box component='img' className={classes.image} src={data?.inactive_icon} alt={data?.active_icon_alt}/>
        <Typography variant='h4' className={classes.blockTitle}>{data?.title}</Typography>
      </Link>
    </ListItem>
  );
};

export default Card;
